export type FileExtensionKind = 'csv' | 'json' | 'parquet' | 'excel' | 'xml' | 'other'

const DELIMITED_EXTENSIONS = new Set(['csv', 'tsv', 'txt'])
const EXCEL_EXTENSIONS = new Set(['xls', 'xlsx'])

export function getFileExtension(fileName: string | null | undefined): string {
  if (!fileName) return ''
  const trimmed = fileName.trim()
  if (!trimmed.includes('.')) return ''
  return trimmed.split('.').pop()?.toLowerCase() ?? ''
}

export function classifyFileExtension(fileName: string | null | undefined): FileExtensionKind {
  const ext = getFileExtension(fileName)
  if (DELIMITED_EXTENSIONS.has(ext)) return 'csv'
  if (ext === 'json') return 'json'
  if (ext === 'parquet') return 'parquet'
  if (EXCEL_EXTENSIONS.has(ext)) return 'excel'
  if (ext === 'xml') return 'xml'
  return 'other'
}

export function directoryOf(filePath: string | null | undefined): string {
  if (!filePath) return ''
  const normalized = filePath.trim()
  if (!normalized) return ''
  const lastSlash = normalized.lastIndexOf('/')
  if (lastSlash <= 0) return ''
  return normalized.slice(0, lastSlash)
}
